import {combineReducers} from 'redux';
// @ts-expect-error
import {createReducer} from 'redux-act';

import type {ReportRowData, TimeseriesReportData} from 'nutshell-core/types';

import type {SiteAnalyticsStats} from '../../../reports/report-summary';

import * as actions from './analytics-actions';

type SiteAnalyticsReportTableData = {
    rows: ReportRowData[] | null | undefined;
    totals: ReportRowData | null | undefined;
    hasError: boolean;
};
type SiteAnalyticsReportState = {
    timeseriesChart: {
        isLoading: boolean;
        isTimedOut: boolean;
        isErrored: boolean;
        chartData: TimeseriesReportData | null | undefined;
        prefix: string;
    };
    tableData: SiteAnalyticsReportTableData;
};
const siteAnalyticsReportDefaultState = {
    timeseriesChart: {
        isLoading: true,
        isTimedOut: false,
        isErrored: false,
        chartData: null,
        prefix: '$',
    },
    tableData: {rows: undefined, totals: undefined},
} as const;

const defaultStat = {value: 0, formatted: '0', prefix: '$', suffix: ''} as const;
const defaultAnalyticsSummaryStats: SiteAnalyticsStats = {
    // @ts-expect-error
    views: {mean: defaultStat, sum: defaultStat},
    // @ts-expect-error
    visitors: {mean: defaultStat, sum: defaultStat},
    // @ts-expect-error
    viewsPerVisit: {mean: defaultStat, sum: defaultStat},
};

type SummaryStatsState = {
    isLoading: boolean;
    stats: SiteAnalyticsStats;
};
const summaryStatsDefaultState = {
    isLoading: true,
    stats: defaultAnalyticsSummaryStats,
} as const;

const siteAnalyticsReportReducer = createReducer(
    {
        [actions.updateSiteAnalyticsReportTableData]: (
            // @ts-expect-error
            state,
            payload: SiteAnalyticsReportTableData
        ) => {
            return {...state, tableData: payload};
        },
        // @ts-expect-error
        [actions.requestSiteAnalyticsReportData]: (state) => {
            const newChartState = {
                ...state.timeseriesChart,
                isLoading: true,
                isTimedOut: false,
                isErrored: false,
            } as const;

            const newTableState = {
                ...state.tableData,
                isLoading: true,
                isTimedOut: false,
                isErrored: false,
            } as const;

            return {...state, timeseriesChart: newChartState, tableData: newTableState};
        },
        // @ts-expect-error
        [actions.updateSiteAnalyticsReportChartData]: (state, {chartData}) => {
            const newChartState = {
                ...state.timeseriesChart,
                isLoading: false,
                isTimedOut: false,
                isErrored: false,
                chartData,
            } as const;

            return {...state, timeseriesChart: newChartState};
        },
        // @ts-expect-error
        [actions.failSiteAnalyticsReportChartData]: (state, err) => {
            if (err) {
                if (err.status === 504 || err.status === 502) {
                    const newChartState = {
                        ...state.timeseriesChart,
                        chartData: null,
                        isLoading: false,
                        isTimedOut: true,
                        isErrored: false,
                    } as const;

                    return {...state, timeseriesChart: newChartState};
                } else {
                    const newChartState = {
                        ...state.timeseriesChart,
                        chartData: null,
                        isLoading: false,
                        isTimedOut: false,
                        isErrored: true,
                    } as const;

                    return {
                        ...state,
                        tableData: {...state.tableData, hasError: true},
                        timeseriesChart: newChartState,
                    };
                }
            }

            return state;
        },
    },
    siteAnalyticsReportDefaultState
);

export const summaryStatsReducer = createReducer(
    {
        // @ts-expect-error
        [actions.requestSiteAnalyticsReportData]: (state) => {
            return {...state, isLoading: true};
        },
        // @ts-expect-error
        [actions.updateAnalyticsSummaryStats]: (state, {stats}) => {
            return {...state, isLoading: false, stats: stats};
        },
    },
    summaryStatsDefaultState
);

export const siteAnalyticsReducer = combineReducers({
    siteAnalyticsReport: siteAnalyticsReportReducer,
    summaryStats: summaryStatsReducer,
});

export type SiteAnalyticsState = {
    siteAnalyticsReport: SiteAnalyticsReportState;
    summaryStats: SummaryStatsState;
};
